import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Pill, PillTone } from "@tenant/ui";
import clsx from "clsx";
import styles from "./GridV2RefreshedPill.module.scss";

export interface GridV2RefreshedPillProps {
  /**
   * `compact` is the mobile pricing-tab variant (Figma 40629:110033): 11px
   * text, 4px 6px padding. `default` is the 24px pill used everywhere else
   * (Figma 40629:108577).
   */
  size?: "default" | "compact";
  /** Appends the decorative arrow glyph the ways-to-pay card header shows. */
  withArrow?: boolean;
  className?: string;
}

/**
 * The yellow "Refreshed" badge that marks the Grid V2 fixed pricing wherever it
 * shows: the pricing tab, the results banner, the ways-to-pay dialog.
 */
export const GridV2RefreshedPill = ({
  size = "default",
  withArrow = false,
  className,
}: GridV2RefreshedPillProps) => {
  const { t } = useI18nContext();
  const [block] = useModuleBEM(styles, "GridV2RefreshedPill", {
    compact: size === "compact",
  });

  return (
    <Pill
      className={clsx(block, className)}
      size="custom"
      tone={PillTone.custom}
    >
      {t("gridV2.refreshedTag")}
      {withArrow && (
        // Design glyph, not content: hidden from screen readers.
        <span aria-hidden="true"> &rarr;</span>
      )}
    </Pill>
  );
};
